if (
  process.env.NODE_ENV === "development" ||
  process.env.REACT_APP_ADRESS_ENV === "development"
) {
  module.exports = {
    srm: "http://10.4.100.111:8051", //测试
    // srm: "http://tf9d966a.natappfree.cc", // 叶海峰
    // srm: "http://c9d69c92.natappfree.cc", // 叶海峰
    wecome_redirect_url: "https://srm-dev.hkbrightfuture.cn/#/login",
    portal: "https://uatportal.hkbf.com.cn",
    uc: "https://uatuc.hkbf.com.cn",
    cm: "https://uatcm.hkbf.com.cn",
    bpmRun: "https://uatbpmrun.hkbf.com.cn",
    oa: "https://uatoaservice.hkbf.com.cn",
    smp: "https://uatsmp.hkbf.com.cn",
    qa: "https://uatcmQA.hkbf.com.cn",
    chartsTemplate: "http://127.0.0.1:3002/zh",
    snake: "http://127.0.0.1:3333",
  };
} else if (process.env.NODE_ENV === "production") {
  module.exports = {
    srm: "http://10.4.100.111:8051",
    wecome_redirect_url: "https://srm-dev.hkbrightfuture.cn/#/login",
    portal: "https://portalservice.hkbf.com.cn",
    uc: "https://ucservice.hkbf.com.cn",
    cm: "https://cmservice.hkbf.com.cn",
    bpmRun: "https://bpmrunservice.hkbf.com.cn",
    oa: "https://oaservice.hkbf.com.cn",
    smp: "https://uatsmp.hkbf.com.cn",
    qa: "https://cmQAservice.hkbf.com.cn",
    chartsTemplate: "http://127.0.0.1:3002/zh",
    snake: "http://127.0.0.1:3333",
  };
}
